import React, { useEffect, useState } from "react"
import { Container, Row, Col, Button, InputGroup, Form } from "react-bootstrap"
import { Search, Trash2, SquarePlus, Pencil } from "lucide-react";
import { Link, useNavigate } from "react-router-dom"
import axios from "axios"
import Swal from "sweetalert2"
import { useForm } from "react-hook-form"
import DataTable from "react-data-table-component"
import OrgTableShimmer from "./Common/OrgTableShimmer"
import CompanySelector from "./Common/CompanySelector"
// import OrgTableShimmer from "./Common/OrgTableShimmer"
// import CompanySelector from "./Common/CompanySelector"
const CustomLoader = () => (
  <OrgTableShimmer columns={5} rows={6} titleWidth="180px" />
)
const paginationComponentOptions = {
  selectAllRowsItem: true,
  selectAllRowsItemText: "All",
}
const Agentlist = () => {
  document.title = "ATS - Agents"
  const navigate = useNavigate()
  const [agents, setAgents] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [loading, setLoading] = useState(false)
  const [companyId, setCompanyId] = useState(null)
  const handleCompanyChange = c => {
    if (c?.company_id) {
      setCompanyId(c.company_id)
    }
  }
  const { register, getValues } = useForm()
  const fetchAgents = async (page = 1, size = perPage) => {
    setLoading(true)
    const searchValue = getValues("searchValue")
    const isSearching = searchValue && searchValue.trim() !== ""
    try {
      const params = {
        page: page,
        size: size,
      }
      if (isSearching) params.search = searchValue.trim()
      if (companyId) params.company_id = companyId

      const response = await axios.get(`/api/v1/agents/`, { params })
      const res = response.data
      const results = res?.data || res?.results || []
      const count = res?.count || results.length
      setAgents(results)
      setTotalRows(count)
    } catch (error) {
      console.error("Error fetching agents:", error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (!companyId) return
    fetchAgents()
  }, [companyId])
  const handlePageChange = page => {
    fetchAgents(page, perPage)
  }
  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage)
    fetchAgents(page, newPerPage)
  }
  const handleDeleteClick = agentId => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (result.isConfirmed) {
        handleConfirmDelete(agentId)
      }
    })
  }
  const handleConfirmDelete = async agentId => {
    try {
      await axios.delete(`/api/v1/agents/?agent_id=${agentId}`)
      fetchAgents(1, perPage)
      Swal.fire("Success", "Agent deleted successfully!", "success")
    } catch (error) {
      Swal.fire("Error", "Failed to delete agent.", "error")
    }
  }
  const columns = [
    {
      name: <span className="fs-6 fw-bold">Agent Name</span>,
      selector: row => row.bot_name,
      sortable: true,
      width: "200px",
      cell: row => <span title={row.bot_name}>{row.bot_name}</span>,
    },
    {
      name: <span className="fs-6 fw-bold">Company Name</span>,
      selector: row => row.agent_company_name,
      sortable: true,
      width: "250px",
      cell: row => <span title={row.agent_company_name}>{row.agent_company_name}</span>,
    },
    {
      name: <span className="fs-6 fw-bold">Company Description</span>,
      selector: row => row.about_the_company,
      sortable: true,
      width: "250px",
      cell: row => (
        <span title={row.about_the_company}>
          {row.about_the_company
            ? row.about_the_company.length > 50
              ? row.about_the_company.substring(0, 50) + "..."
              : row.about_the_company
            : "-"}
        </span>
      ),
    },
    {
      name: <span className="fs-6 fw-bold">Company Website</span>,
      selector: row => row.agent_company_website,
      sortable: true,
      cell: row => (
        <a
          href={row.agent_company_website}
          target="_blank"
          rel="noreferrer"
          title={row.agent_company_website}
        >
          {row.agent_company_website}
        </a>
      ),
      width: "240px",
    },
    
    {
      name: <span className="fs-6 fw-bold">Voice</span>,
      selector: row => row.voice_code || "-",
      sortable: true,
      width: "220px",
      cell: row => <span title={row.voice_code || "-"}>{row.voice_code || "-"}</span>,
    },
    {
      name: <span className="fs-6 fw-bold">Call Timing</span>,
      selector: row => row.meeting_duration,
      sortable: true,
      width: "150px",
      cell: row => <span title={row.meeting_duration}>{row.meeting_duration}</span>,
    },
    {
      name: <span className="fs-6 fw-bold">Created At</span>,
      selector: row => row.created_at,
      sortable: true,
      width: "200px",
      cell: row => {
        const val = row.created_at
          ? new Date(row.created_at).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })
          : "-"
        return <span title={val}>{val}</span>
      },
    },
    {
      name: <span className="fs-6 fw-bold">Updated At</span>,
      selector: row => row.updated_at,
      sortable: true,
      width: "200px",
      cell: row => {
        const val = row.updated_at
          ? new Date(row.updated_at).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })
          : "-"
        return <span title={val}>{val}</span>
      },
    },
    {
      name: <span className="fs-6 fw-bold">Created By</span>,
      sortable: true,
      width: "180px",
      selector: row => [row.created_by_user_first_name, row.created_by_user_middle_name, row.created_by_user_last_name].filter(Boolean).join(" "),
      cell: row => {
        const name = [row.created_by_user_first_name, row.created_by_user_middle_name, row.created_by_user_last_name].filter(Boolean).join(" ") || "-"
        return <span title={name}>{name}</span>
      },
    },
    {
      name: <span className="fs-6 fw-bold">Status</span>,
      width: "100px",
      cell: row => (
        <span
          title={row.is_active ? "Active" : "Inactive"}
          // className={` ${row.is_active ? "bg-success" : "bg-secondary"}`}
        >
          {row.is_active ? "Active" : "Inactive"}
        </span>
      ),
      width: "110px",
    },
    {
      name: <span className="fs-6 fw-bold">Action</span>,
      cell: row => (
        <div className="d-flex align-items-center gap-3">
          <Link to={`/agentcreation?id=${row.id}`} className="text-success">
            <Pencil size={20} />
          </Link>
          <span
            className="text-danger"
            style={{ cursor: "pointer" }}
            onClick={() => handleDeleteClick(row.id)}
          >
            <Trash2 size={20} />
          </span>
        </div>
      ),
      width: "150px",
    },
  ]
  return (
    <div className="page-content allact-tabs">
      <Container fluid>
        <div className="page-title-box mb-0 p-3">
          <Row className="align-items-center">
            <Col xxl={6}>
              <h1 className="page-title">Agents List</h1>
            </Col>
            <Col xxl={6}>
              <Row className="justify-content-end align-items-center">
                <Col md={4} lg={3}>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={() => navigate("/agentcreation")}
                  >
                    <SquarePlus size={18} /> &nbsp; Create Agent
                  </Button>
                </Col>
                <Col md={4} lg={3}>
                  <label>Select Company</label>
                  <CompanySelector onCompanyChange={handleCompanyChange} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="card p-2" id="ExtensionLogs_Datatable">
          <DataTable
            columns={columns}
            data={agents}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={perPage}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            highlightOnHover
            striped
            responsive
            paginationComponentOptions={paginationComponentOptions}
            persistTableHead
            fixedHeader
            fixedHeaderScrollHeight="700px"
            progressPending={loading}
            progressComponent={<CustomLoader />}
          />
        </div>
      </Container>
    </div>
  )
}
export default Agentlist
